export const ACTUAL_VOLUME_CONTENT_DDI = 72
export const ACTUAL_MASS_CONTENT_DDI = 75
export const ACTUAL_COUNT_CONTENT_DDI = 78

export const SETPOINT_VOLUME_PER_AREA_DDI = 1
export const SETPOINT_MASS_PER_AREA_DDI = 6
export const SETPOINT_COUNT_PER_AREA_DDI = 11

export const DEFAULT_VOLUME_PER_AREA_DDI = 3
export const DEFAULT_MASS_PER_AREA_DDI = 8
export const DEFAULT_COUNT_PER_AREA_DDI = 13

export const TOTAL_AREA_DDI = 116
